import { FC } from 'react';

import image from '../../../../../assets/images/clapping-hands.png';
import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import Button from '../../../../../components/button/index';

type SignatureSigningSuccessProps = {
  canSignNextDocument: boolean;
  onBackToMySignatures: () => void;
  onSignNextDocument: () => void;
};

export const SignatureSigningSuccess: FC<SignatureSigningSuccessProps> = ({
  canSignNextDocument,
  onBackToMySignatures,
  onSignNextDocument,
}) => {
  return (
    <div
      aria-live="polite"
      className="mx-6 mb-6 flex h-full flex-1 flex-col items-center justify-center overflow-y-auto rounded-2xl px-6 py-10 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.06),0px_2px_3px_0px_rgba(16,24,40,0.10),0px_-1px_3px_0px_rgba(16,24,40,0.04)]"
    >
      <span
        aria-hidden
        className="flex size-[140px] items-center justify-center rounded-full border-[12px] border-white shadow-lg"
        style={{
          background:
            'linear-gradient(180deg, rgba(108, 233, 166, 0.10) 0%, rgba(3, 152, 85, 0.10) 100%)',
        }}
      >
        <img alt="clapping hands" className="size-16" src={image} />
      </span>
      <p
        className="mt-8 !bg-clip-text text-center text-4xl font-bold text-transparent"
        style={{
          background: `linear-gradient(132.59deg, #475467 29.58%, #101828 84.27%)`,
        }}
      >
        <AppFormattedMessage id="ALL_DONE" />!
      </p>
      <p className="mt-4 max-w-[350px] text-center text-sm text-gray-500">
        <AppFormattedMessage id="SIGNATURE_SIGNING_SUCCESS_MESSAGE" />
      </p>
      <div className="mt-8 w-full max-w-[458px] rounded-lg bg-gray-50 p-6">
        <p className="text-base font-semibold text-brand-700">
          <AppFormattedMessage id="WHATS_NEXT" />
        </p>
        <p className="mt-3 text-sm text-gray-700">
          <AppFormattedMessage id="SIGNATURE_SIGNING_SUCCESS_WHATS_NEXT_MESSAGE" />
        </p>
      </div>
      <div className="mt-8 flex w-full max-w-[458px] items-center justify-center gap-3">
        <Button
          className="max-w-[184px] border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-700"
          onClick={onBackToMySignatures}
          styleType="NONE"
          type="button"
        >
          <AppFormattedMessage id="BACK_TO_MY_SIGNATURES" />
        </Button>
        {canSignNextDocument && (
          <Button className="max-w-[264px] px-4 py-2.5" onClick={onSignNextDocument} type="button">
            <AppFormattedMessage id="SIGN_NEXT_DOCUMENT" />
          </Button>
        )}
      </div>
    </div>
  );
};
